import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PdfIcon',
  props: {
  size: { default: 24 },
  variant: null,
  fill: null
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})